/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{makeFeatureFromGroupPart as t}from"./support/builderUtils.js";import{isPolygon as e}from"../support/executorUtils.js";function o({templatePart:o,shape:s,edits:p,relationships:r,mode:i}){e(s)&&t({templatePart:o,shape:s.clone(),edits:p,relationships:r,mode:i})}const s=!1;export{o as execute,s as isAsync};
